import { Component, OnDestroy } from '@angular/core';
import { FileUploadComponent } from '../../shared-components/upload/file-upload/file-upload.component';
import { FileApiService } from 'src/app/data-transfer/services/file-api-service';
import { TranslocoService } from '@jsverse/transloco';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SimpleDialogData } from '../simple-alert-dialog/simple-alert-dialog.component';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { DirectoryDto } from 'src/app/data-transfer/entities/directory-dto';
import { getDialogConfig } from 'src/app/util/dialog-util';
import { SelectLocationDialogComponent } from '../../directory-tree/dialogs/select-location-dialog/select-location-dialog.component';
import { DialogActions } from 'src/app/model/dictionary';
import { PackagingUnitText } from 'src/app/model/path-building-blocks';

@Component({
  selector: 'app-packaging-excel-upload-dialog',
  templateUrl: './packaging-excel-upload-dialog.component.html',
  styleUrls: ['./packaging-excel-upload-dialog.component.scss']
})
export class PackagingExcelUploadDialogComponent extends FileUploadComponent implements OnDestroy {
  excelFile: File | null = null;

  spinnerActive: boolean = false;
  selectedFolder: DirectoryDto|null = null;

  constructor(
    private dialogRef: MatDialogRef<PackagingExcelUploadDialogComponent>,
    protected dialog: MatDialog,
    private translateService: TranslocoService,
    private fileApiService: FileApiService,
    private router: Router,
    private directoryApiService: DirectoryApiService,
  ) {
    super(dialog);
  }

  uploadCreateUnit() {
    if (!this.excelFile || !this.selectedFolder) { return; }
    const formData: FormData = super.getNewFilesFormData([this.excelFile], 'file');
    const folderId: number = this.selectedFolder.id;

    this.spinnerActive = true;
    this.excelFile = null;
    this.selectedFolder = null;

    this.fileApiService.putExcelPackagingUnit(formData, folderId, true).subscribe(_ => {
      this.spinnerActive = false;
      this.dialogRef.close();
      this.router.navigate([PathResolveService.getDirectoryManagementPath(true, folderId.toString(), PackagingUnitText)]);
    }, error => {
      console.log(error);
      console.log(typeof(error));
      this.spinnerActive = false;
      const dialogData = this.getErrorDialogData(error);
      this.showDialog(dialogData, '500px');
    });
  }

  openExcelFile(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files) {
      const excelFile = target.files[0];
      if (!excelFile) { return; }
      const fileType = excelFile.type;
      if (fileType.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') === null) {
        const dialogData = this.getInvalidFormatDialogData(excelFile.name);
        this.showDialog(dialogData);
        return;
      }
      this.excelFile = excelFile;
    }
  }
  openFolderSelection() {
    this.directoryApiService.getDirectories().subscribe(rootFolder => {
       const unreachableFolders : DirectoryDto[] = []
       const data = { rootFolder , unreachableFolders };
          const dialogConfig = getDialogConfig(data, '500px');
          const dialogRef = this.dialog.open(SelectLocationDialogComponent, dialogConfig);
          dialogRef.afterClosed().subscribe(result => {
            if (result.event === DialogActions.REJECT) { return; }
              this.selectedFolder = result.data;
            });
          });
    }

  ngOnDestroy(): void {
    this.excelFile = null;
    super.ngOnDestroy();
  }

  private getInvalidFormatDialogData(fileName: string): SimpleDialogData {
    return {
      title: fileName,
      messages: [this.translateService.translate('errors.formatNotSupported')],
      icon: 'error'
    };
  }

  private getErrorDialogData(error: HttpErrorResponse): SimpleDialogData {
    if (error.error == 'Packaging unit already exists!') {
      return {
        title: this.translateService.translate('errors.excelUpload.packagingUnitAlreadyExistsTitle'),
        messages: [this.translateService.translate('errors.excelUpload.packagingUnitAlreadyExistsMessage')],
        icon: 'error'
      };
    }

    if(error.error == 'Packaging unit already exists in the excel file!') {
      return {
        title: this.translateService.translate('errors.excelUpload.packagingUnitAlreadyExistsTitle'),
        messages: [this.translateService.translate('errors.excelUpload.packagingUnitAlreadyOnExcelExistsMessage')],
        icon: 'error'
      };
    }

    return {
      title: this.translateService.translate('errors.excelUpload.defaultTitle'),
      messages: [this.translateService.translate('errors.excelUpload.defaultMessage')],
      icon: 'error'
    };
  }
}
